import {
  coversAnyCompany,
  type Permission,
  permissionCoverage,
  type SessionSummary,
} from '@jaf/contracts';

/**
 * Indica se a sessão concede a permissão em alguma empresa do escopo selecionado
 * (`companyIds` nulo = grupo inteiro). Mesma regra da API (`permissionCoverage`), mas é só
 * controle visual: a API revalida em toda requisição.
 */
export function canInScope(
  session: SessionSummary | null,
  permission: Permission,
  companyIds: readonly string[] | null,
): boolean {
  if (session === null) return false;
  return coversAnyCompany(permissionCoverage(session.roles, permission), companyIds);
}

/**
 * Indica se a sessão concede a permissão em todas as empresas informadas (ex.: a empresa do
 * título e as do rateio). Controle visual; a API revalida em toda requisição.
 */
export function canInEveryCompany(
  session: SessionSummary | null,
  permission: Permission,
  companyIds: readonly string[],
): boolean {
  if (session === null || companyIds.length === 0) return false;
  const coverage = permissionCoverage(session.roles, permission);
  return companyIds.every((companyId) => coversAnyCompany(coverage, [companyId]));
}
